export interface IAddress {
  id: number;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface IAddressApiModel {
  id: number;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  createdAt: string;
  updatedAt: string;
}

export default class Address implements IAddress {
  public readonly id: number;

  public readonly address1: string;

  public readonly address2: string;

  public readonly city: string;

  public readonly state: string;

  public readonly zip: string;

  public readonly createdAt: Date;

  public readonly updatedAt: Date;

  constructor(
    id: number,
    address1: string,
    address2: string,
    city: string,
    state: string,
    zip: string,
    createdAt: Date,
    updatedAt: Date,
  ) {
    this.id = id;
    this.address1 = address1;
    this.address2 = address2;
    this.city = city;
    this.state = state;
    this.zip = zip;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
  }

  static fromApiModel(apiModel: IAddressApiModel) {
    const { id, address1, address2, city, state, zip } = apiModel;

    const createdAt = new Date(Date.parse(apiModel.createdAt));
    const updatedAt = new Date(Date.parse(apiModel.updatedAt));

    return new Address(
      id,
      address1,
      address2,
      city,
      state,
      zip,
      createdAt,
      updatedAt,
    );
  }

  static arrayFromApiModel(arrayApiModel: IAddressApiModel[]) {
    const array = arrayApiModel.map(apiModel => {
      const { id, address1, address2, city, state, zip } = apiModel;

      const createdAt = new Date(Date.parse(apiModel.createdAt));
      const updatedAt = new Date(Date.parse(apiModel.updatedAt));

      return new Address(
        id,
        address1,
        address2,
        city,
        state,
        zip,
        createdAt,
        updatedAt,
      );
    });

    return array;
  }
}
